import {useSelector} from 'react-redux';

import {getHttpIncidentColumns} from 'features/http/lib/httpIncidentView';
import {userSelector} from 'entities/user';

export const useHttpIncidents = (hideMonitor: boolean) => {
    const user = useSelector(userSelector);

    return {
        columns: getHttpIncidentColumns(hideMonitor),
        tzString: user?.timezone,
    };
};

export default useHttpIncidents;
